export default __webpack_public_path__ + "static/hw_ff_led_schem-123d67c7d396fc0bc50fbf75c481e3c4.png";